// extracted by mini-css-extract-plugin
export default {"btop":"a1886e551f e10764d714 ceac1f3a0f","icon":"d3382b00f4 d302c74872","btoppink":"e1653e866d af71073858"};